import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import { IconButton, Link } from '@material-ui/core/';
import Typography from '@material-ui/core/Typography';
import { fade, makeStyles } from '@material-ui/core/styles';
import MenuIcon from '@material-ui/icons/Menu';
import { deepOrange, deepPurple } from '@material-ui/core/colors';


const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
      backgroundColor: '#394b59',
      color: '#2c91c7',
    },
    orange: {
      color: theme.palette.getContrastText(deepOrange[500]),
      backgroundColor: deepOrange[500],
    },
    purple: {
      color: theme.palette.getContrastText(deepPurple[500]),
      backgroundColor: deepPurple[500],
    },
    link: {
      cursor: 'pointer',
        color: '#fff',
        '&:hover': {
          color: '#f5365c',
        },
    },
    menuButton: {
      marginRight: theme.spacing(2),
    },
    title: {
      color: '#f5365c',
      flexGrow: 1,
      [theme.breakpoints.up('sm')]: {
        display: 'block',
      },
    },
    search: {
      position: 'relative',
      borderRadius: theme.shape.borderRadius,
      backgroundColor: fade(theme.palette.common.black, 0.15),
      '&:hover': {
        backgroundColor: fade(theme.palette.common.white, 0.25),
      },
      marginLeft: 0,
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        marginLeft: theme.spacing(1),
        width: 'auto',
      },
    },
    searchIcon: {
      padding: theme.spacing(0, 2),
      height: '100%',
      position: 'absolute',
      pointerEvents: 'none',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      color: '#fad2d2',
    },
    inputRoot: {
      color: 'inherit',
    },
    inputInput: {
      padding: theme.spacing(1, 1, 1, 0),
      // vertical padding + font size from searchIcon
      paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
      transition: theme.transitions.create('width'),
      width: '100%',
      [theme.breakpoints.up('sm')]: {
        width: '15ch',
        '&:focus': {
          width: '25ch',
        },
      },
    },
}));

const Spacer = () => {
  return (<>&nbsp;&nbsp;&nbsp;&nbsp;</>);
}

const NavBar = (props) => {
    const classes = useStyles();

    const onDrawerClicked = (event) => {
        console.info('drawer clicked');
    }

    const defaultProps = {
        color: 'primary',
        children: <Link
            style={{ color: 'white' }}
            underline='none'
            href='/wallet'
            onClick={(e) => {
                console.info("Let's go glass clicked", e);
            }}
            >
            Glass
        </Link>,
    }

    return (
        <div className={classes.root}>
            <AppBar position="static"  className={classes.root} >
                <Toolbar>
                <IconButton
                    edge="start"
                    className={classes.menuButton}
                    color="inherit"
                    aria-label="open drawer"
                    onClick={onDrawerClicked}
                >
                    <MenuIcon />
                </IconButton>&nbsp;
               <Spacer />
                <Link
                    style={{ color: '#fd5d93' }}
                    href='/'
                    underline='none'
                    onClick={(e) => {
                        console.info("Home clicked", e.target);
                    }}
                >
                    Home
                </Link>
                <Spacer />
                <Link
                    style={{ color: '#fd5d93' }}
                    underline='none'
                    href='/exchange'
                    onClick={(e) => {
                        console.info("Exchange clicked", e);
                    }}
                >
                    Exchange
                </Link>
                <Spacer />
                <Link
                    style={{ color: '#fd5d93' }}
                    underline='none'
                    href='/marketplace'
                    onClick={(e) => {
                        console.info("Let's go marketplace clicked", e);
                    }}
                >
                    Marketplace
                </Link>
                <Spacer />
                {/* <Badge badgeContent={127.42} max={999} {...defaultProps} /> */}
                {/* <Link
                    style={{ color: '#fd5d93' }}
                    underline='none'
                    href='/wallet'
                    onClick={(e) => {
                        console.info("Let's go glass clicked", e);
                    }}
                >
                    Glass
                </Link> */}
                <Spacer />{/* &nbsp;&nbsp;
                <Avatar className={classes.purple}>JR</Avatar> */}
                <Typography className={classes.title} variant="h6" noWrap>
                    RawCipher 1.0
                </Typography>
                {/* <div className={classes.search}>
                    <div className={classes.searchIcon}>
                        <SearchIcon />
                    </div>
                    <InputBase
                        placeholder="Search"
                        classes={{
                            root: classes.inputRoot,
                            input: classes.inputInput,
                        }}
                        inputProps={{ 'aria-label': 'search' }}
                    />
                </div> */}
                </Toolbar>
            </AppBar>
        </div>
  );
}

export default NavBar;